export const SERVICE_PAGE_NAME = 'service-page';
export const SERVICE_LIST_PAGE_NAME = 'book-online';

export enum FailReasons {
  Premium = 'premium',
  PricingPlanNotInstalled = 'pricing_plan_not_installed',
  NoPlansAssignedToService = 'no_plans_assigned_to_service',
}
